<template>
  <div
    class="dropzone-container"
    @dragover.prevent="handleDragOver"
    @dragleave.prevent="handleDragLeave"
    @drop.prevent="handleDrop"
    :class="{ 'drag-over': isDragging }"
  >
    <input
      ref="fileInput"
      type="file"
      accept=".xlsx"
      @change="handleFileChange"
      style="display: none;"
    />
    
    <div v-if="!selectedFile" class="dropzone-content">
      <v-icon size="64" color="primary">mdi-cloud-upload</v-icon>
      <h3 class="text-h6 mt-4">{{ $t('massive.dropzone.dragDrop') }}</h3>
      <p class="text-body-2 mt-2">{{ $t('massive.dropzone.clickSelect') }}</p>
      <v-btn
        outlined
        color="primary"
        class="mt-4"
        @click="triggerFileInput"
      >
        <v-icon left>mdi-folder-open</v-icon>
        {{ $t('massive.dropzone.selectFile') }}
      </v-btn>
    </div>

    <div v-else class="file-info">
      <v-icon size="64" color="success">mdi-file-excel</v-icon>
      <h3 class="text-h6 mt-4">{{ selectedFile.name }}</h3>
      <p class="text-body-2 mt-2">{{ formatFileSize(selectedFile.size) }}</p>
      <v-btn
        outlined
        color="error"
        class="mt-4"
        @click="removeFile"
      >
        <v-icon left>mdi-delete</v-icon>
        {{ $t('massive.dropzone.removeFile') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MassiveUploadDropzone',
  components: {},
  data() {
    return {
      isDragging: false,
      selectedFile: null
    };
  },
  methods: {
    handleDragOver() {
      this.isDragging = true;
    },
    handleDragLeave() {
      this.isDragging = false;
    },
    handleDrop(event) {
      this.isDragging = false;
      const file = event.dataTransfer.files[0];
      this.validateAndSetFile(file);
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      this.validateAndSetFile(file);
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    validateAndSetFile(file) {
      if (!file) return;

      const allowedExtensions = ['.xlsx'];
      const fileName = file.name.toLowerCase();
      const isValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));

      if (!isValidExtension) {
        this.$emit('error', this.$t('massive.dropzone.invalidExtension'));
        return;
      }

      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        this.$emit('error', this.$t('massive.dropzone.exceedsMaxSize'));
        return;
      }

      this.selectedFile = file;
      this.$emit('file-selected', file);
    },
    removeFile() {
      this.selectedFile = null;
      this.$refs.fileInput.value = '';
      this.$emit('file-removed');
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    }
  }
};
</script>

<style lang="css" scoped>
.dropzone-container {
  border: 2px dashed #6E17A5;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  background: rgba(110, 23, 165, 0.05);
  transition: all 0.3s ease;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.dropzone-container.drag-over {
  border-color: #6E17A5;
  background: rgba(110, 23, 165, 0.1);
  transform: scale(1.02);
}

.dropzone-content,
.file-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.dropzone-content .text-h6,
.file-info .text-h6 {
  word-break: break-word;
  line-height: 1.3;
  max-width: 100%;
}

.dropzone-content .text-body-2,
.file-info .text-body-2 {
  word-break: break-word;
  line-height: 1.4;
  max-width: 100%;
}
</style>
